import { classes as htmlClasses } from 'html-classes';
import { observer } from 'mobx-react-lite';
import { forwardRef } from 'react';
import { Link } from 'react-router-dom';

import {
  cfSrcForImage,
  createCategoryUrl,
} from '~/components/CategoryBlocks/utils';
import { CloudflareResizeOptions } from '~/components/CloudflareResponsiveImage/CloudflareResizeOptions';
import { useCategoryAnalytics } from '~/hooks/useCategoryAnalytics';
import { useGlobal } from '~/hooks/useGlobal';

import styles from './Card.module.scss';
import { CardProps } from './interfaces';

const Card = forwardRef<HTMLAnchorElement, CardProps>(
  ({ classes, category }, ref) => {
    const { name, id, previewImage } = category;
    const { root: className, titleClassName } = classes || {};

    const { handleClickCategory } = useCategoryAnalytics();
    const { isMobile } = useGlobal();

    const size: CloudflareResizeOptions = isMobile
      ? { width: 360, height: 360 }
      : { width: 560, height: 560 };

    return (
      <Link
        to={createCategoryUrl({ id })}
        onClick={handleClickCategory(id)}
        ref={ref}
        className={htmlClasses([styles.root, className])}
        style={{
          backgroundImage: `url(${cfSrcForImage(previewImage, size)})`,
        }}
      >
        <h4 lang="es" className={htmlClasses([styles.title, titleClassName])}>
          {name}
        </h4>
      </Link>
    );
  },
);

Card.displayName = 'Card';

export default observer(Card);
